import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function AuthCallback() {
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState('processing')
  const [message, setMessage] = useState('Procesando autenticación...')
  const navigate = useNavigate()
  const { login } = useAuth()

  useEffect(() => {
    const processCallback = async () => {
      try {
        const code = searchParams.get('code')
        const error = searchParams.get('error')
        const state = searchParams.get('state')

        if (error) {
          setStatus('error')
          setMessage(`Error de autenticación: ${error}`)
          setTimeout(() => navigate('/login'), 3000)
          return
        }

        if (!code) {
          setStatus('error')
          setMessage('Código de autorización no encontrado')
          setTimeout(() => navigate('/login'), 3000)
          return
        }

        // Aquí procesarías el código de autorización con Authorizer
        // Por ahora, simplemente redirigimos al dashboard
        setStatus('success')
        setMessage('Autenticación exitosa. Redirigiendo...')
        
        setTimeout(() => navigate('/dashboard'), 2000)
      } catch (error) {
        console.error('Error procesando callback:', error)
        setStatus('error')
        setMessage('Error procesando la autenticación')
        setTimeout(() => navigate('/login'), 3000)
      }
    }

    processCallback()
  }, [searchParams, navigate, login])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Autenticación
          </h2>
        </div>
        <div className="mt-8 space-y-6">
          <div className="text-center">
            {status === 'processing' && (
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
            )}
            {status === 'success' && (
              <div className="rounded-full h-12 w-12 bg-green-100 mx-auto flex items-center justify-center">
                <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
            )}
            {status === 'error' && (
              <div className="rounded-full h-12 w-12 bg-red-100 mx-auto flex items-center justify-center">
                <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </div>
            )}
            <p className="mt-4 text-sm text-gray-600">{message}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthCallback